import { validationTypes } from "../../../components/forms/libs/data/ValidationTypes";
import { FileFormats } from "../../../components/forms/libs/data/fileFormatTypes";
import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";
import { ImageFormats } from "../../../components/forms/libs/data/imageFormatTypes";

export const HideShowVideoUrlConfig = [
    {
        id: "videoUrl",
        label: "Video Url",
        Field_Name: "Video Url",
        fieldType: FormFieldTypes.INPUT,
        dataField: "videoUrl",
        fieldSetting: {
            placeholder: "Enter Video URL",
            allowSpace: true,
            textareaRows: 4,
        },
        validation: [{ type: validationTypes.REQUIRE }],
        style: {
            containerCss: "col-lg-6 col-md-6",
        },
    },
]

export const HideShowPDFUploadConfig = [
     {
        id: "ReportFileName",
        label:"PDF Upload",
        Field_Name: "PDF Upload",
        fieldType: FormFieldTypes.FILE,
        dataField: "ReportFileName",
        fieldSetting: {
          isDownloadButton: true,
          allowMultipleFiles: false,
          acceptedFileFormats: [
            FileFormats.PDF,
            FileFormats.DOC,
            FileFormats.DOCX,
            FileFormats.XLSX,
          ],
          minFileSizeInMB: 0, // Minimum File size in MB
          maxFileSizeInMB: 2, // Maximum File size in MB
        },
        validation: [{ type: validationTypes.REQUIRE }],
        style: {
          containerCss:
            "col-lg-12 col-md-12 validation-text-fileuploader",
        },
      },
]

export const HideShowRedirectUrlConfig = [
    {
        id: "redirectUrl",
        label: "Url",
        Field_Name: "Url",
        fieldType: FormFieldTypes.INPUT,
        dataField: "redirectUrl",
        fieldSetting: {
            placeholder: "",
            allowSpace: true,
            textareaRows: 4,
        },
        validation: [{ type: validationTypes.REQUIRE }],
        style: {
            containerCss: "col-lg-6 col-md-6",
        },
    },
]

export const addSpeakerConfig = [
    {
        id: "speaker",
        label: "Speaker Name",
        Field_Name: "Speaker Name",
        fieldType: FormFieldTypes.TEXTEDITOR,
        dataField: "speaker",
        fieldSetting: {
          allowSpace: true,
        },
        validation: [{ type: validationTypes.REQUIRE }],
        style: {
          containerCss: "col-xxl-8 col-xl-8 col-md-8 col-8 mt-4",
        },
      },
      {
        id: "displaySpeakerImage",
        label: "Upload Speaker Image",
        Field_Name: "Upload Speaker Image",
        fieldType: FormFieldTypes.IMAGE,
        dataField: "displaySpeakerImage",
        fieldSetting: {
          placeholder: "Upload Speaker Image",
          allowMultipleFiles: false,
          acceptedImageFormats: [
            ImageFormats.JPEG,
            ImageFormats.BMP,
            ImageFormats.JPG,
            ImageFormats.PNG,
            ImageFormats.WEBP,
          ],
          minFileSizeInMB: 0,
          maxFileSizeInMB: 8,
        },
        validation: [{ type: validationTypes.REQUIRE }],
        style: {
          containerCss: "col-lg-4 col-md-4 validation-text-fileuploader mt-4",
        },
      },

]